import axios from 'axios';

interface TwitterOEmbedResponse {
  url: string;
  author_name: string;
  author_url: string;
  html: string;
  width: number;
  height: number | null;
  type: string;
  cache_age: string;
  provider_name: string;
  provider_url: string;
  version: string;
}

const getClip = async (id: string, username?: string): Promise<TwitterOEmbedResponse | undefined> => {
  try {
    const url = username
      ? `https://twitter.com/${username}/status/${id}`
      : `https://twitter.com/i/status/${id}`;

    const { data } = await axios.get(
      `https://publish.twitter.com/oembed?url=${encodeURIComponent(url)}`
    );
    return data;
  } catch (error) {
    console.error('Twitter API error:', error);
    return undefined;
  }
};

const twitterApi = { getClip };
export default twitterApi;
